import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineAsyncComponent } from "vue";
export default {
  //@ts-ignore
  "login-modal": defineAsyncComponent(() => import("../Modals/LoginModal.vue")),
  //@ts-ignore
  "menu-user-modal": defineAsyncComponent(() => import("../../vue/Modals/MenuUserModal.vue")),
  //@ts-ignore
  "app-banner": defineAsyncComponent(() => import("../../vue/AppBanner.vue")),
  //@ts-ignore
  "password-modal": defineAsyncComponent(() => import("../../vue/Modals/PasswordModals/PasswordModal.vue")),
  //@ts-ignore
  "update-password-modal": defineAsyncComponent(() => import("../../vue/Modals/PasswordModals/UpdatePasswordModal.vue")),
  //@ts-ignore
  "signin-modal": defineAsyncComponent(() => import("@vmodals/Signin/SigninModal.vue")),
  //@ts-ignore
  "email-confirm-modal": defineAsyncComponent(() => import("../../vue/Modals/EmailConfirmModal.vue")),
  //@ts-ignore
  "email-confirmed-modal": defineAsyncComponent(() => import("../../vue/Modals/EmailModals/EmailConfirmedModal.vue")),
  //@ts-ignore
  "email-confirmed-modal-error": defineAsyncComponent(() => import("../../vue/Modals/EmailModals/EmailConfirmedModalError.vue")),
  //@ts-ignore
  "password-recovery-modal": defineAsyncComponent(() => import("../../vue/Modals/PasswordModals/PasswordRecoveryModal.vue")),
  //@ts-ignore
  "password-recovery-modal-sent": defineAsyncComponent(() => import("../../vue/Modals/PasswordModals/PasswordRecoveryModalSent.vue")),
  //@ts-ignore
  "suggestion-modal": defineAsyncComponent(() => import("../../vue/Modals/SuggestionModal.vue")),
  //@ts-ignore
  "base-snackbar": defineAsyncComponent(() => import("@vueEntry/BaseSnackbar.vue")),
  //@ts-ignore
  "signin-with-mail": defineAsyncComponent(() => import("@vueEntry/Modals/Signin/SigninWithMail.vue")),
  //@ts-ignore
  "publish-modal": defineAsyncComponent(() => import("@vueEntry/Modals/PublishModal.vue")),
  //@ts-ignore
  "auction-property-modal": defineAsyncComponent(() => import("@vueEntry/Modals/AuctionPropertyModal.vue"))
};